<style>
#codeLog{
	/* padding:30px 30px 8px 30px!important; */
	height: calc(100vh - 128px)!important;
}
#codeLog .q-table__middle{
	overflow-y: hidden !important;
	overflow-x: auto !important;
	height:calc(100% - 48px)!important;
	width: 100%;
}
#codeLog .q-table{
	overflow: hidden !important;
	height:100% !important;
	width: 100%;
}
#codeLog tbody{
	display: block;
	max-height: calc(100vh - 300px);
	height:100%;
	width: 100%;
	overflow: auto;
	webkit-overflow-scrolling: touch;
	will-change: scroll-position;
}
#codeLog .q-table thead{
	height: 48px;
	display: block;
}
#codeLog .q-table thead tr{
	width: 100%;
	display: table;
}
#codeLog .q-table tbody tr{
	width: 100%;
	display: table;/*table-row*/
}
#codeLog .q-table th, #codeLog .q-table tbody td{
    font-size: 0.95rem;
}
#codeLog .q-table th, #codeLog .q-table td {
    padding: 7px 8px;
}
#codeLog .q-table td {
	word-wrap: break-word;
    word-break: break-all;
    white-space: normal;
}
#codeLog .q-table__bottom{
	color: #888;
	position: absolute;
	bottom: 0;
	width: 100%;
	padding: 0 15px;
}
#codeLog .q-table__bottom, #codeLog .q-table__bottom .q-if {
    font-size: 0.88rem;
}
</style>
<template>
  <q-page id="codeLog" padding>
  	<q-card class="fit">
  		<q-card-section style="height: 60px;padding:10px 15px;" :style="{padding:screenType?'30px 30px 8px 30px!important':'8px'}">
  			<q-input v-model="keyword" @keyup.enter="getData(1)" :placeholder="$t('key')" maxlength="15" style="width:210px;float:right;" rounded outlined dense >
  			  <template v-slot:after>
  			    <q-btn @click="getData(1)" icon="fa fa-search" color="white" text-color="primary" round dense />
  			  </template>
  			</q-input>
  		</q-card-section>
  		<q-separator />
  		<q-card-section class="q-pa-none" style="height:calc(100% - 60px);"><!-- :selected.sync="selected" selection="multiple"-->
  			<q-table class="fit" :data="listData" :columns="columns" :loading="loading" :pagination.sync="page" :rows-per-page-options="[15,20,30]" row-key="id">
  				<tr slot="header" slot-scope="props">
  					<!--<q-th style="width:4%;"><q-checkbox v-if="props.multipleSelect" v-model="props.selected" indeterminate-value="some"/></q-th>-->
          			<q-th key="id" :props="props" style="width:6%;min-width: 80px">ID</q-th>
          			<q-th key="programName" :props="props" style="width:24%;min-width: 150px">{{$t('code.name')}}</q-th>
					<!-- <q-th key="deviceName" :props="props" style="width:22%;">{{$t('code.name')}}</q-th> -->
          			<q-th key="materialIdentify" :props="props" style="width:35%;min-width: 150px">{{$t('code.flag')}}</q-th>
          			<q-th key="materialResult" :props="props" style="width:35%;min-width: 150px">{{$t('code.result')}}</q-th>
          			<!-- <q-th key="createTime" :props="props" style="width:18%;">{{$t('createTime')}}</q-th> -->
          		</tr>
          		<q-tr slot="body" slot-scope="props" :props="props">
          			<!--<q-td style="width:4%;"><q-checkbox v-model="props.selected"/></q-td>-->
          			<!--<q-td key="id" :props="props" style="width:6%;">{{ (props.row.__index+1)+(curPage-1)*page.rowsPerPage }}</q-td>-->
          			<q-td key="id" :props="props" style="width:6%;min-width: 80px">{{ props.row.id }}</q-td>
          			<q-td key="programName" :props="props" style="width:24%;min-width: 150px">{{ props.row.programName }}</q-td>
					<!-- <q-td key="deviceName" :props="props" style="width:22%;">{{ props.row.deviceName }}</q-td> -->
          			<q-td key="materialIdentify" :props="props" style="width:35%;min-width: 150px">{{ props.row.materialIdentify }}</q-td>
          			<q-td key="materialResult" :props="props" style="width:35%;min-width: 150px">{{ props.row.materialResult }}</q-td>
          			<!--<q-td key="createTime" :props="props" style="width:18%;">{{ props.row.createTime |parseDateTime}}</q-td>-->
          		</q-tr>
          		<div slot="pagination" slot-scope="props" class="row flex-center q-py-sm">
          			<q-btn @click="pageClick(0)" :disable="curPage<=1" icon="fas fa-arrow-left" color="primary" size="sm" round dense/>
          			<div class="q-mx-md" style="font-size: small"> {{ curPage }} / {{ totalPage }} </div>
          			<q-btn @click="pageClick(1)" :disable="nextPage" icon="fas fa-arrow-right" color="primary" size="sm" round dense/>
          		</div>
  			</q-table>
  		</q-card-section>
  	</q-card>

  </q-page>
</template>
<script>
export default {
  name: 'codeLog',
  data () {
    return {
    	keyword:null,
    	selected:[],
    	total:0,
    	curPage:1,
    	page:{ page:1, rowsPerPage:20 },
    	loading:false,
    	columns: [{ name: 'id', field: 'id', align: 'left', sortable: true},
        { name: 'programName', field: 'programName', align: 'left', sortable: true },
        //{ name: 'deviceName', field: 'deviceName', align: 'left', sortable: true },
        { name: 'materialIdentify', field: 'materialIdentify', align: 'left', sortable: true },
        { name: 'materialResult', field: 'materialResult', align: 'left'},
		//{ name: 'createTime', field: 'createTime', align: 'left', sortable: true },
    	],
    	listData:[],
    }
  },
  props:['lang'],
  filters: {
    	parseDateTime(time){
    		return time?parseDateTime(time):time;
    	}
    },
  watch:{
  	lang(val, oldVal){
    	this.columns = this.columns;
    },
    pageCount(val, oldVal){//选每页数量 size
    	if(val){
    		this.curPage = 1;
    		this.getData(this.curPage);
    	}
    },
  },
  computed: {
	  			screenType() {
      return _isPC(); //this.$q.platform.is.desktop
    },
  	nextPage(){
  		return this.curPage>=Math.ceil(this.total/this.page.rowsPerPage);
  	},
  	totalPage(){
  		return Math.ceil(this.total/this.page.rowsPerPage);
  	},
  	pageCount(){
  		return this.page.rowsPerPage;
  	}
  },
  created(){
  	if(localStorage.getItem("AS_token") && localStorage.getItem("AS_token").length>0) {
    	this.getData(1);
  	}else{
  		this.$router.replace('/');//login
  	}
  },
  methods: {
  	getData(index){
    	this.listData = [];
    	this.loading = true;
    	var request = {};
    	//request.ids = [];
		if(this.keyword) request.keyword = this.keyword;
    	request.paging = { index:(index-1)*this.page.rowsPerPage, count:this.page.rowsPerPage, sort:'desc' };
    	this.$ajax(1,'post',true,'/transcodingLog/list',request).then((res)=>{
    		this.listData = res.data;
    		this.total = res.paging.total;
    		setTimeout(() => { this.loading = false }, 800);
    	}).catch((err)=>{
    		console.log(err)
    		setTimeout(() => { this.loading = false }, 800);
    		this.$emit('islogin',index==1?0:1,err);
    		//if(err.code) this.$notify(2,err.msg,null);
    	})
    },
  	btnClick(type,index){

  	},
  	confirm(){

  	},
  	pageClick(type){//点击页数 type:0-,1+
    	this.curPage= type? this.curPage+1:this.curPage-1;
    	if(this.curPage>0&&this.total!==0&&this.listData.length<this.total){
    		this.getData(this.curPage);
    	}
    },
  }
}
</script>
